var _rect, _rect2, _rect3, _rect4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChartPlaceholder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, ["title", "titleId"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 91 91",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-5.08475,-4.79601)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.67315,0,0,1,-55.1589,1.27119)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.06254,0,0,1.06254,0,-2.15851)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.887,90.291C50.671,90.477 67.75,90.291 84.535,90.291L84.535,85.904L36.628,85.904L36.628,5.349L33.887,5.349L33.887,90.291Z",
    style: {
      fillRule: "nonzero"
    }
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.042,
    y: 25.636,
    width: 14.822,
    height: 59.534
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 75.216,
    y: 41.737,
    width: 14.822,
    height: 43.432
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 35.199,
    y: 47.246,
    width: 14.822,
    height: 37.924
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 55.195,
    y: 56.568,
    width: 14.822,
    height: 28.602
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartPlaceholder);
export default __webpack_public_path__ + "static/media/chart_placeholder.f384ea73.svg";
export { ForwardRef as ReactComponent };